<template>
  <div>
    <v-stepper v-model="stepper">
      <v-stepper-header>
        <v-stepper-step :complete="stepper > 1" step="1">
          Información Básica
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="stepper > 2" step="2">
          Perfil
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="stepper > 3" step="3">
          Actividades
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-progress-linear
            value="15"
            indeterminate
            absolute
            top
            v-if="this.$store.state.charge.isLoading"
          ></v-progress-linear>
          <v-form ref="formCarge" v-model="formCharge">
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="model.name"
                    :rules="[this.$store.state.rules.required]"
                    label="Nombre"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    :items="this.$store.state.status.chargePermissions"
                    v-model="model.can_create_report"
                    :rules="[this.$store.state.rules.required]"
                    label="Puede Crear Informe?"
                    required
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    :items="this.$store.state.status.chargePermissions"
                    v-model="model.can_reviewer_report"
                    :rules="[this.$store.state.rules.required]"
                    label="Puede Editar Informe?"
                    required
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    :items="this.$store.state.status.chargePermissions"
                    v-model="model.can_add_statistics"
                    :rules="[this.$store.state.rules.required]"
                    label="Puede Agregar Estadisticas?"
                    required
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    :items="this.$store.state.status.chargePermissions"
                    v-model="model.can_add_achievements"
                    :rules="[this.$store.state.rules.required]"
                    label="Puede Agregar Logros?"
                    required
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    :items="this.$store.state.status.chargePermissions"
                    v-model="model.can_add_accompaniments"
                    :rules="[this.$store.state.rules.required]"
                    label="Puede Crear Acompañamientos?"
                    required
                  ></v-select>
                </v-col>               

                <v-col cols="12" md="12">
                  <v-textarea
                    :items="this.$store.state.status.chargePermissions"
                    v-model="model.help_text"
                    :rules="[this.$store.state.rules.required]"
                    label="Texto de ayuda"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>

          <v-btn color="primary" @click="nextStepAnnexe"> Continuar </v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-data-table
            :headers="headers"
            :items="model.annexes"
            class="elevation-1 mb-7"
            no-data-text="No hay registros agregados..."
            hide-default-footer
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Anexos</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogAddAnnexe" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Agregar
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline"
                        >{{ titleDialogAnnexe }} Anexo</span
                      >
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-form ref="formAnnexe" v-model="formAddAnnexe">
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="modelAnnexe.name"
                                label="Nombre"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-textarea
                                v-model="modelAnnexe.value"
                                label="Descripción"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeAnnexe">
                        Cancelar
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="saveAnnexe">
                        {{ titleDialogAnnexe }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDeleteAnnexe" max-width="500px">
                  <v-card>
                    <v-card-title class="headline"
                      >Seguro que desea eliminar este anexo?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="closeDeleteAnnexe"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="deleteAnnexeConfirm"
                        >Aceptar</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="green"
                    v-bind="attrs"
                    v-on="on"
                    @click="editAnnexe(item.item)"
                  >
                    <v-icon dark> mdi-circle-edit-outline </v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="red"
                    v-bind="attrs"
                    v-on="on"
                    @click="deleteAnnexe(item.item)"
                  >
                    <v-icon dark> mdi-delete </v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <v-btn color="primary" @click="nextStepTypeActivity">
            Siguiente
          </v-btn>
          <v-btn text @click="stepper = 1"> Volver </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-data-table
            :headers="headersTypeActivities"
            :items="model.type_activities"
            class="elevation-1 mb-7"
            no-data-text="No hay registros agregados..."
            hide-default-footer
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Tipos de Actividades</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogAddTypeActivity" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Agregar
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline"
                        >{{ titleDialogTypeActivity }} Tipo de actividad</span
                      >
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-form ref="formTypeActivity" v-model="formAddAnnexe">
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="modelTypeActivity.name"
                                label="Nombre"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="closeTypeActivity"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="saveTypeActivity"
                      >
                        {{ titleDialogTypeActivity }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDeleteTypeActivity" max-width="520px">
                  <v-card>
                    <v-card-title class="headline"
                      >Seguro que desea eliminar esta actividad?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="closeDeleteTypeActivity"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="deleteTypeActivityConfirm"
                        >Aceptar</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="item">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="green"
                    v-bind="attrs"
                    v-on="on"
                    @click="editTypeActivity(item.item)"
                  >
                    <v-icon dark> mdi-circle-edit-outline </v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="red"
                    v-bind="attrs"
                    v-on="on"
                    @click="deleteTypeActivity(item.item)"
                  >
                    <v-icon dark> mdi-delete </v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <v-btn color="primary" @click="saveCharge"> Guardar </v-btn>
          <v-btn text @click="stepper = 2"> Volver </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import { SET_ALERT } from "@/store/alert";
export default {
  name: "Create",
  data: () => ({
    stepper: 1,
    dialogAddAnnexe: false,
    dialogDeleteAnnexe: false,
    currentAnnexe: null,
    dialogAddTypeActivity: false,
    dialogDeleteTypeActivity: false,
    currentTypeActivity: null,
    formCharge: true,
    formAddAnnexe: true,
    model: {
      name: "",
      duration: "",
      can_create_report: "",
      can_reviewer_report: "",
      can_add_statistics: "",
      can_add_achievements: "",
      can_add_accompaniments: "",
      help_text: "",
      annexes: [],
      type_activities: [],
    },
    modelAnnexe: {
      name: "",
      value: "",
    },
    modelTypeActivity: {
      name: "",
    },
    headers: [
      { text: "Nombre", value: "name", sortable: false },
      { text: "Descripción", value: "value", sortable: false },
      { text: "Acción", value: "actions", sortable: false },
    ],
    headersTypeActivities: [
      { text: "Nombre", value: "name", sortable: false },
      { text: "Acción", value: "actions", sortable: false },
    ],
    editedIndexAnnexe: -1,
    editedIndexTypeActivity: -1,
  }),
  computed: {
    titleDialogAnnexe() {
      return this.currentAnnexe ? "Editar" : "Agregar";
    },
    titleDialogTypeActivity() {
      return this.currentTypeActivity ? "Editar" : "Agregar";
    },
  },
  methods: {
    nextStepAnnexe() {
      if (!this.$refs.formCarge.validate()) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }

      this.stepper = 2;
    },
    editAnnexe(item) {
      this.editedIndexAnnexe = this.model.annexes.indexOf(item);
      this.currentAnnexe = Object.assign({}, item);
      this.modelAnnexe = Object.assign({}, item);
      this.dialogAddAnnexe = true;
    },
    deleteAnnexe(item) {
      this.editedIndexAnnexe = this.model.annexes.indexOf(item);
      this.currentAnnexe = Object.assign({}, item);
      this.dialogDeleteAnnexe = true;
    },
    deleteAnnexeConfirm() {
      this.model.annexes.splice(this.editedIndexAnnexe, 1);
      this.closeDeleteAnnexe();
    },
    closeAnnexe() {
      this.dialogAddAnnexe = false;
      this.$nextTick(() => {
        this.currentAnnexe = null;
        this.modelAnnexe = {
          name: "",
          value: "",
        };
        this.editedIndexAnnexe = -1;
        this.$refs.formAnnexe.resetValidation();
      });
    },
    closeDeleteAnnexe() {
      this.dialogDeleteAnnexe = false;
      this.$nextTick(() => {
        this.currentAnnexe = null;
        this.editedIndexAnnexe = -1;
      });
    },
    saveAnnexe() {
      if (this.currentAnnexe) {
        Object.assign(
          this.model.annexes[this.editedIndexAnnexe],
          this.modelAnnexe
        );
      } else {
        this.model.annexes.push(this.modelAnnexe);
      }
      this.closeAnnexe();
    },
    nextStepTypeActivity() {
      if (this.model.annexes.length == 0) {
        this.$store.commit(SET_ALERT, {
          message: "Debe agregar mínimo un anexo",
          type: "error",
        });
        return;
      }

      this.stepper = 3;
    },
    editTypeActivity(item) {
      this.editedIndexTypeActivity = this.model.type_activities.indexOf(item);
      this.currentTypeActivity = Object.assign({}, item);
      this.modelTypeActivity = Object.assign({}, item);
      this.dialogAddTypeActivity = true;
    },
    deleteTypeActivity(item) {
      this.editedIndexTypeActivity = this.model.type_activities.indexOf(item);
      this.currentTypeActivity = Object.assign({}, item);
      this.dialogDeleteTypeActivity = true;
    },
    deleteTypeActivityConfirm() {
      this.model.type_activities.splice(this.editedIndexTypeActivity, 1);
      this.closeDeleteTypeActivity();
    },
    closeTypeActivity() {
      this.dialogAddTypeActivity = false;
      this.$nextTick(() => {
        this.currentTypeActivity = null;
        this.modelTypeActivity = {
          name: "",
        };
        this.editedIndexTypeActivity = -1;
        this.$refs.formTypeActivity.resetValidation();
      });
    },
    closeDeleteTypeActivity() {
      this.dialogDeleteTypeActivity = false;
      this.$nextTick(() => {
        this.currentTypeActivity = null;
        this.editedIndexTypeActivity = -1;
      });
    },
    saveTypeActivity() {
      if (this.currentTypeActivity) {
        Object.assign(
          this.model.type_activities[this.editedIndexTypeActivity],
          this.modelTypeActivity
        );
      } else {
        this.model.type_activities.push(this.modelTypeActivity);
      }
      this.closeTypeActivity();
    },
    async saveCharge() {
      if (this.model.type_activities.length == 0) {
        this.$store.commit(SET_ALERT, {
          message: "Debe agregar mínimo un tipo de actividad",
          type: "error",
        });
        return;
      }
      this.$store.dispatch("createCharge", this.model);
    },
  },
};
</script>

<style>
</style>